export enum LegalInfoType {
    CookiePolicy = 'CookiePolicy',
    LegalInfo = 'LegalInfo',
    TermAndConditions = 'TermsAndConditions',
    PrivacyPolicy = 'PrivacyPolicy',
    AppInfo = 'AppInfo',
}
